import React from 'react'
import "../Footer.css";

function Footer() {
  return (
    <footer className="footerF text-center">
      <a href="#myPage" title="To Top">
        <span className="glyphicon glyphicon-chevron-up"></span>
      </a>
      <p> © 2022 Jobs Finder. Made By : Group 1</p>
    </footer>
  );
}
export default Footer;
